export default __webpack_public_path__ + "static/media/Our-Services-Top-right.2864aba1.png";